import { createContext as t } from "react";
const e = t(null);
export {
  e as RouterContext
};
//# sourceMappingURL=index.es5.js.map
